import {handleApiError} from './common.js'
import moduleEditItem from './module-edit-item.js'
import itemPayload from '../item-payload.js'

export default function buildModuleUpdate(properties, parsed) {
  const SET_LOADING = 'SET_LOADING'
  const SET_ERROR = 'SET_ERROR'
  return moduleEditItem({
    state: {
      error: '',
      isLoading: false,
    },
    actions: {
      load: ({commit, dispatch}, id) => {
        return new Promise((resolve, reject) => {
          commit(SET_LOADING, true)
          dispatch('reset').then(() => {
            dispatch('api/fetch', {uri: id}, {root: true})
              .then(response => response.json())
              .then((data) => {
                dispatch('setItem', data)
                  .then((data) => {
                    commit(SET_LOADING, false)
                    commit(SET_ERROR, '')
                    resolve(data)
                  })
              })
              .catch((e) => {
                commit(SET_LOADING, false)
                commit(SET_ERROR, e.message)
                reject(e)
              })
          })
        })
      },
      save: ({ commit, dispatch, getters }) => {
        commit(SET_ERROR, '')
        commit(SET_LOADING, true)

        return new Promise((resolve, reject) => {
          dispatch('api/put', {uri: getters.item['@id'], options: {
              body: JSON.stringify(itemPayload(properties, getters.item))
            }}, { root: true })
            .then(response => response.json())
            .then((data) => {
              commit(SET_LOADING, false)
              commit(SET_ERROR, '')
              Promise.all([
                dispatch('setViolations', null),
                dispatch('setItem', data)
              ]).then(() => {
                resolve(data)
              })
            })
            .catch((error) => {
              commit(SET_LOADING, false)
              handleApiError({commit, dispatch}, error)
              reject(error)
            })
        })
      },
    },
    getters: {
      error: state => state.error,
      isLoading: state => state.isLoading
    },
    mutations: {
      [SET_ERROR] (state, error) {
        Object.assign(state, { error })
      },
      [SET_LOADING] (state, isLoading) {
        Object.assign(state, { isLoading })
      },
    }
  }, {properties, parsed})
}
